import { Box, BoxProps } from "@chakra-ui/react";

export function UnPinIcon({ ...props }: BoxProps) {
  return (
    <Box cursor={"pointer"} {...props}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2501 16.668C15.7989 16.7747 15.4162 16.7866 14.994 17.0504C14.227 17.5295 14.0426 18.0986 14.2403 18.9689C14.9503 22.0962 17.9051 25.051 21.0324 25.761C21.903 25.9587 22.4718 25.7746 22.9514 25.0077C23.201 24.6086 23.2264 24.1747 23.3334 23.7513"
          stroke="#5C6670"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20 16.4993C20.148 16.4816 20.2652 16.4503 20.3579 16.402C21.1664 15.9807 21.6076 14.6113 22.0415 13.8334C22.4426 13.1143 22.6432 12.7547 23.115 12.5852C23.5867 12.4157 23.8706 12.5184 24.4385 12.7237C25.7664 13.2037 26.7962 14.2336 27.2763 15.5615C27.4816 16.1293 27.5843 16.4133 27.4148 16.885C27.2453 17.3568 26.8857 17.5574 26.1666 17.9585C25.384 18.395 23.9962 18.8423 23.5754 19.6582C23.5287 19.7486 23.4982 19.8606 23.4808 20"
          stroke="#5C6670"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 27.4987L16.6667 23.332"
          stroke="#5C6670"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 12.5L27.5 27.5"
          stroke="#5C6670"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}
